import { Flyout as BaseFlyout } from '@avensia/excite-ui';
import { styled } from '@glitz/react';

export const Flyout = styled(BaseFlyout, {
  width: 480,
});
